export default __webpack_public_path__ + "static/estimates_placeholder-89e8aeeba7322cb6c99bc056836aa43a.png";